var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientsMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H87.5L100 12.5V100H0V0Z",
    fill: "#00CC99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5001 58.9948L51.4751 60.0189H40V65.0142H53.5251L57.5001 61.0429V52.5259H37.5V57.5212H52.5001V58.9948Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4751 47.5304L60.7251 58.2454L64.2751 61.792L73.5251 52.5257H75.0001V56.497L58.9751 72.507H35V45.0327H20V80H35V77.5023H61.0251L80.0001 58.5451V47.5304H71.4751ZM30 75.0047H25V50.028H30V75.0047Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5001 42.5352H62.5001V47.5305H67.5001V37.5399H59.0501C60.5905 36.2059 61.6859 34.4335 62.1898 32.4601C62.6937 30.4867 62.5818 28.4065 61.8693 26.4984C61.1567 24.5903 59.8775 22.9453 58.2029 21.7839C56.5284 20.6224 54.5386 20 52.5001 20C50.4616 20 48.4717 20.6224 46.7972 21.7839C45.1227 22.9453 43.8434 24.5903 43.1309 26.4984C42.4183 28.4065 42.3065 30.4867 42.8103 32.4601C43.3142 34.4335 44.4097 36.2059 45.9501 37.5399H37.5V47.5305H42.5001V42.5352ZM52.5001 25.0516C53.489 25.0516 54.4557 25.3445 55.2779 25.8934C56.1002 26.4423 56.741 27.2225 57.1195 28.1353C57.4979 29.048 57.5969 30.0524 57.404 31.0214C57.2111 31.9904 56.7349 32.8805 56.0356 33.5791C55.3364 34.2777 54.4454 34.7535 53.4755 34.9462C52.5056 35.139 51.5003 35.0401 50.5867 34.662C49.673 34.2839 48.8921 33.6436 48.3427 32.8221C47.7933 32.0007 47.5001 31.0349 47.5001 30.0469C47.5001 28.722 48.0269 27.4515 48.9645 26.5147C49.9022 25.5779 51.174 25.0516 52.5001 25.0516Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsMini);
export default __webpack_public_path__ + "static/media/clients_mini.dfed2cdfe3fa0a9f6874117da285080f.svg";
export { ForwardRef as ReactComponent };